import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDownloaderComponent } from './file-downloader.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } }
  ],
  declarations: [
    // FileDownloaderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule, 
    MaterialModule,
    ReactiveFormsModule
    // FormsModule
  ],
  // exports: [FileDownloaderComponent]
})
export class FileDownloaderModule { }